import { useEffect, useState } from 'react'

import { getAttachmentAssetKey } from './useAttachmentTypes'

export const useMediaCounter = ({ images }: { images: string[] }) => {
  const [index, setIndex] = useState(0)
  const [isImageError, setIsImageError] = useState(false)

  // Polling re-signs the URLs every few seconds (new strings, same assets), so
  // the reset keys on the stable asset paths: incident navigation resets the
  // carousel, a poll tick does not.
  const imagesKey = images.map(getAttachmentAssetKey).join(',')
  useEffect(() => {
    setIndex(0)
    setIsImageError(false)
  }, [imagesKey])

  // Render-time clamp covers the frame before the reset effect runs when a
  // shorter list arrives — an out-of-range index must never classify
  // images[index] === undefined as a downloadable attachment.
  const safeIndex = Math.min(index, Math.max(images.length - 1, 0))

  const handleClickNext = () => {
    if (safeIndex + 1 < images.length) {
      setIsImageError(false)
      setIndex(safeIndex + 1)
    }
  }
  const handleClickPrevious = () => {
    if (safeIndex - 1 >= 0) {
      setIsImageError(false)
      setIndex(safeIndex - 1)
    }
  }
  const handleImageError = () => {
    setIsImageError(true)
  }
  return {
    index: safeIndex,
    isImageError,
    handleImageError,
    handleClickNext,
    handleClickPrevious,
  }
}
